import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Admin.css";

const LogistikPR = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [permohonanData, setPermohonanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tanggal, setTanggal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching user info:", err);
      });

    fetchPermohonanData();
  }, []);

  const fetchPermohonanData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/permohonan_belum_divalidasi_logistik",
        { withCredentials: true }
      );
      setPermohonanData(
        response.data.permohonan_belum_divalidasi_logistik || []
      );
      setError(null);
    } catch (err) {
      console.error("Error fetching permohonan:", err);
      setError("Gagal memuat data permintaan kebun dari server.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (err) {
      console.error("Error during logout:", err);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handleBack = () => {
    navigate("/logistikp");
  };

  const handleValidate = (pengiriman_id) => {
    Swal.fire({
      title: "Validasi Permintaan Kebun",
      text: "Tentukan status persetujuan untuk permohonan logistik ini:",
      icon: "question",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: '<i class="fa fa-check me-1"></i> Approve',
      denyButtonText: '<i class="fa fa-times me-1"></i> Reject',
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      denyButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        denyButton: "rounded-pill px-4 fw-bold shadow-sm",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        submitValidation(pengiriman_id, "approved", "");
      } else if (result.isDenied) {
        Swal.fire({
          title: "Alasan Penolakan",
          input: "textarea",
          inputLabel: "Berikan catatan alasan mengapa permintaan ini ditolak:",
          inputPlaceholder: "Tuliskan alasan penolakan secara jelas...",
          showCancelButton: true,
          confirmButtonText: "Kirim Penolakan",
          cancelButtonText: "Batal",
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#6c757d",
          customClass: {
            confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
            cancelButton: "rounded-pill px-4 fw-medium",
          },
          inputValidator: (value) => {
            if (!value || !value.trim()) {
              return "Alasan penolakan wajib diisi!";
            }
          },
        }).then((noteResult) => {
          if (noteResult.isConfirmed) {
            submitValidation(pengiriman_id, "rejected", noteResult.value);
          }
        });
      }
    });
  };

  const submitValidation = (pengiriman_id, status, note) => {
    axios
      .post(
        "https://c-greenproject.org:7500/validate_logistik",
        {
          pengiriman_id,
          status,
          note,
        },
        { withCredentials: true }
      )
      .then((response) => {
        Swal.fire({
          title: "Berhasil!",
          text: response.data.message || "Status validasi berhasil diperbarui.",
          icon: "success",
          confirmButtonColor: "#198754",
          customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
        });

        setPermohonanData((prevData) =>
          prevData.map((item) =>
            item.pengiriman_id === pengiriman_id
              ? {
                  ...item,
                  status_logistik: status,
                  tracking_id: response.data.tracking_id || item.tracking_id,
                }
              : item
          )
        );
      })
      .catch((err) => {
        Swal.fire({
          title: "Gagal!",
          text: err.response?.data?.error || err.message,
          icon: "error",
          confirmButtonColor: "#198754",
        });
      });
  };

  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s.includes("approved") || s.includes("disetujui") || s.includes("terima")) {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill fw-semibold">
          Approved
        </span>
      );
    }
    if (s.includes("rejected") || s.includes("ditolak")) {
      return (
        <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill fw-semibold">
          Rejected
        </span>
      );
    }
    return (
      <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-2 rounded-pill fw-semibold text-capitalize">
        {status || "Menunggu Validasi"}
      </span>
    );
  };

  const totalPages = Math.ceil(permohonanData.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = permohonanData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" /> {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/logistik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/logistikp")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/logistikp") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.includes("/logistikp") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Shipping" /> Pengiriman
            </div>
            <div
              onClick={() => navigate("/logistikrp")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistikrp" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistikrp" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Validasi Permintaan Kebun</h2>
              <p className="text-muted small mb-0">
                Pemeriksaan dan persetujuan alokasi armada atas permintaan logistik dari unit perkebunan.
              </p>
            </div>
            <button
              className="btn btn-outline-secondary rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left me-2"></i>Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <h4 className="fw-bold text-success mb-3">Daftar Permintaan Menunggu Validasi</h4>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat daftar permintaan kebun...</p>
              </div>
            ) : error ? (
              <div className="alert alert-danger rounded-3 p-3">
                <i className="fa fa-exclamation-triangle me-2"></i> {error}
              </div>
            ) : currentData && currentData.length > 0 ? (
              <>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                    <thead className="table-light text-nowrap">
                      <tr>
                        <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                        <th className="text-center py-3" style={{ width: "160px" }}>ID Pengiriman</th>
                        <th className="text-center py-3" style={{ width: "160px" }}>Rencana Panen ID</th>
                        <th className="text-center py-3" style={{ width: "180px" }}>Tracking ID</th>
                        <th className="text-center py-3" style={{ width: "180px" }}>Status Logistik</th>
                        <th className="text-center py-3" style={{ width: "140px", borderTopRightRadius: "10px" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((item, index) => (
                        <tr key={`permohonan-${item.pengiriman_id || index}`}>
                          <td className="text-center fw-bold text-muted">
                            {startIndex + index + 1}
                          </td>
                          <td className="text-center font-monospace fw-semibold text-secondary">
                            #{item.pengiriman_id || "-"}
                          </td>
                          <td className="text-center font-monospace fw-bold text-dark">
                            {item.rencana_panen_id ? `#${item.rencana_panen_id}` : "-"}
                          </td>
                          <td className="text-center font-monospace">
                            <span className="badge bg-light text-dark border px-2 py-1">
                              {item.tracking_id || "Belum Ada"}
                            </span>
                          </td>
                          <td className="text-center">
                            {getStatusBadge(item.status_logistik)}
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-warning btn-sm rounded-pill px-3 fw-medium text-dark shadow-sm"
                              onClick={() => handleValidate(item.pengiriman_id)}
                            >
                              <i className="fa fa-edit me-1"></i> Validasi
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <nav className="mt-4">
                    <ul className="pagination justify-content-end mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-start-pill"
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={`page-logpr-${index + 1}`}
                          className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link shadow-none"
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-end-pill"
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-inbox mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Tidak Ada Permintaan Menunggu</h5>
                <p className="mb-0">Semua permohonan logistik dari pihak kebun telah diproses dan divalidasi.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogistikPR;